module.exports = __webpack_public_path__ + "img/image78.e3e629d2.jpg";